import { Injectable } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class PagePreloaderService {

  public isLoading = new BehaviorSubject(true);

  constructor(
    private router: Router
  ) { }

  public bindChangeRoute(): BehaviorSubject<boolean> {
    this.router.events
      .filter(event => event instanceof NavigationStart)
      .subscribe( event => this.isLoading.next(true) );

    this.router.events
      .filter(event => event instanceof NavigationEnd)
      .subscribe( event => this.isLoading.next(false) );

    return this.isLoading;
  }

}



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/page-preloader.service.ts